import { useEffect, useState } from "react";
import { MessageCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, dettaglioErrore } from "@/lib/api";

export function waLink(telefono, testo) {
  const numero = String(telefono).replace(/\D/g, "");
  return `https://wa.me/${numero}?text=${encodeURIComponent(testo)}`;
}

export function WhatsAppGira({ testo, contesto }) {
  const [destinatari, setDestinatari] = useState([]);
  const [connesso, setConnesso] = useState(false);
  const [invioA, setInvioA] = useState(null);

  useEffect(() => {
    api
      .get("/admin/whatsapp/destinatari")
      .then((r) => setDestinatari(r.data.filter((d) => d.attivo)))
      .catch(() => {});
    api
      .get("/admin/wa-web/stato")
      .then((r) => setConnesso(r.data.stato === "connesso"))
      .catch(() => {});
  }, []);

  if (destinatari.length === 0) return null;

  const inviaDiretto = async (d) => {
    setInvioA(d.id);
    try {
      await api.post("/admin/wa-web/invia", { telefono: d.telefono, testo });
      toast.success(`Inviato su WhatsApp a ${d.nome}`);
    } catch (err) {
      toast.error("Invio non riuscito", { description: dettaglioErrore(err) });
    } finally {
      setInvioA(null);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`wa-gira-${contesto}`}>
      <span className="text-xs text-slate-500">
        {connesso ? "Invia dal tuo WhatsApp:" : "Gira su WhatsApp:"}
      </span>
      {destinatari.map((d) =>
        connesso ? (
          <button
            key={d.id}
            type="button"
            data-testid={`wa-gira-${contesto}-${d.id}`}
            onClick={() => inviaDiretto(d)}
            disabled={invioA === d.id}
            className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-3.5 py-1.5 text-xs font-semibold text-emerald-400 transition-colors hover:bg-emerald-500/20 disabled:opacity-60"
          >
            {invioA === d.id ? (
              <Loader2 size={13} className="animate-spin" />
            ) : (
              <MessageCircle size={13} />
            )}
            {d.nome}
          </button>
        ) : (
          <a
            key={d.id}
            data-testid={`wa-gira-${contesto}-${d.id}`}
            href={waLink(d.telefono, testo)}
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              api
                .post("/admin/track", {
                  azione: "Intervento girato su WhatsApp",
                  dettaglio: `${contesto} → ${d.nome}`,
                })
                .catch(() => {})
            }
            className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-3.5 py-1.5 text-xs font-semibold text-emerald-400 transition-colors hover:bg-emerald-500/20"
          >
            <MessageCircle size={13} /> {d.nome}
          </a>
        )
      )}
    </div>
  );
}
